import React from "react";
import { CommonUtil } from "../utils/CommonUtil";

interface PricingSubRow {
    lineItem: string;
    billingLogic: string;
    configuredAmount: any;
    actualAmount: any;
    refund: string;
}

interface PricingLineItem {
    lineItem: string;
    billingLogic: string;
    refund: string;
    subRows?: PricingSubRow[];
}

interface PricingDetailsTableProps {
    pricingLineItems: PricingLineItem[];
    selectedViewType: string;
    isMarketplace: boolean;
    hubodometer: boolean;
    distanceToTravel: any;
    setDistanceToTravel: (val: any) => void;
    engineUnitUsage: any;
    setEngineUnitUsage: (val: any) => void;
    handleBillingLogicChange: (index: number, value: string) => void;
    handleRefundChange: (index: number, value: string) => void;
    handleActualAmountChange: (mainIndex: number, subIndex: number | null, value: string) => void;
}

const PricingDetailsTable: React.FC<PricingDetailsTableProps> = ({
    pricingLineItems,
    selectedViewType,
    isMarketplace,
    hubodometer,
    distanceToTravel,
    setDistanceToTravel,
    engineUnitUsage,
    setEngineUnitUsage,
    handleBillingLogicChange,
    handleRefundChange,
    handleActualAmountChange
}) => {
    return (
        <div className="row mt-4 mb-1">
            <div className="col-12">
                <table className="table table-bordered table-sm">
                    <thead>
                        <tr style={{ backgroundColor: "#f8f9fa", fontWeight: "bold" }}>
                            <th style={{ width: '23%' }}>Line Item</th>
                            <th style={{ width: '15%' }}>Billing Logic</th>
                            <th style={{ width: '17%' }}>Configured Amount</th>
                            <th style={{ width: '15%' }}>Actual Amount</th>
                            {(!CommonUtil.IS_GENERIC_EQUIP && selectedViewType === "ASSIGN_RENTER_VIEW") && (
                                <th style={{ width: '14%' }}>Usage / Day</th>
                            )}
                            <th style={{ width: '15%' }}>Refund logic</th>
                        </tr>
                    </thead>
                    <tbody>
                        {pricingLineItems.map((mainItem, mainIndex) => (
                            <React.Fragment key={mainIndex}>
                                {/* Main Row */}
                                <tr>
                                    <td style={{ paddingTop: '8px' }} className="fw-semibold">{mainItem.lineItem}</td>
                                    <td>
                                        <select
                                            className="form-select fw-semibold border-0 shadow-none px-1"
                                            value={mainItem.billingLogic}
                                            onChange={(e: any) => handleBillingLogicChange(mainIndex, e.target.value)}
                                        >
                                            <option value="Fixed">Fixed</option>
                                            {mainItem.lineItem === "Engine Rate" || mainItem.lineItem === "Distance Rates" ? (
                                                <option value="Actual">Actual</option>
                                            ) : (
                                                <option value="Pro Rated">Pro Rated</option>
                                            )}
                                        </select>
                                    </td>
                                    <td></td>
                                    <td></td>
                                    {(!CommonUtil.IS_GENERIC_EQUIP && selectedViewType === "ASSIGN_RENTER_VIEW") && (
                                        <td></td>
                                    )}
                                    <td>
                                        <select
                                            className="form-select fw-semibold border-0 shadow-none px-1"
                                            value={mainItem.refund}
                                            onChange={(e: any) => handleRefundChange(mainIndex, e.target.value)}
                                        >
                                            <option value="Refund">Refund</option>
                                            <option value="Non Refund">Non Refund</option>
                                        </select>
                                    </td>
                                </tr>
                                {/* Sub Rows */}
                                {mainItem.subRows && mainItem.subRows.map((subItem, subIndex) => (
                                    <tr key={`${mainIndex}-${subIndex}`}>
                                        <td style={{ paddingLeft: '30px', paddingTop: '10px' }}>{subItem.lineItem}</td>
                                        <td style={{ paddingLeft: '30px', paddingTop: '10px' }}>{subItem.billingLogic}</td>
                                        <td>
                                            <div style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-around',
                                                backgroundColor: subItem.billingLogic === "Fixed" ? "#e9ecef" : "transparent"
                                            }}>
                                                <span className={subItem.billingLogic === "Fixed" ? "p-1" : ""}>{subItem.configuredAmount}</span>
                                                {subItem.billingLogic !== "Fixed" && (
                                                    <button
                                                        type="button"
                                                        className="btn btn-link btn-sm ms-2 px-1"
                                                        title="Copy configured to actual"
                                                        onClick={() => {
                                                            handleActualAmountChange(mainIndex, subIndex, subItem.configuredAmount);
                                                        }}
                                                    >
                                                        <i className="fa fa-arrow-right" />
                                                    </button>
                                                )}
                                            </div>
                                        </td>
                                        <td>
                                            <div className={`${(!isMarketplace && (mainItem.lineItem === "Rental Rates" || (mainItem.lineItem === "Distance Rates" && hubodometer))) ? 'mandatory-border' : ''}`}
                                                style={(!isMarketplace && !subItem.actualAmount && (mainItem.lineItem === "Rental Rates" || (mainItem.lineItem === "Distance Rates" && hubodometer)))
                                                    ? { border: '1px solid #f78e8e' } : { border: '0.1px dotted #e9ecef' }}>
                                                <input
                                                    type="number"
                                                    className="form-control border-0 shadow-none"
                                                    placeholder={`${mainItem.lineItem === "Engine Rate" || (mainItem.lineItem === "Distance Rates" && !hubodometer) ? "0" : ""}`}
                                                    value={subItem.actualAmount}
                                                    onChange={(e: any) => handleActualAmountChange(mainIndex, subIndex, e.target.value)}
                                                    onKeyPress={mainItem.lineItem === "Rental Rates" ? CommonUtil.allowNumWOZero : undefined}
                                                /></div>
                                        </td>
                                        {(!CommonUtil.IS_GENERIC_EQUIP && selectedViewType === "ASSIGN_RENTER_VIEW") && (
                                            <td>
                                                {mainItem.lineItem === "Distance Rates" && (
                                                    <div className={`d-flex align-items-center ${(!distanceToTravel || distanceToTravel === 0) ? 'mandatory-border' : ''}`}
                                                        style={(!distanceToTravel || distanceToTravel === 0) ? { border: '1px solid #f78e8e' } : {}}>
                                                        <input
                                                            type="text"
                                                            className="form-control border-0 shadow-none p-0"
                                                            value={distanceToTravel}
                                                            onChange={(e: any) => setDistanceToTravel(e.target.value)}
                                                            onKeyPress={CommonUtil.allowNumWOZero}
                                                        />
                                                        <span style={{ fontSize: '10px', marginLeft: '2px' }}>km/day</span>
                                                    </div>
                                                )}
                                                {mainItem.lineItem === "Engine Rate" && (
                                                    <div className={`d-flex align-items-center`}
                                                        style={{}}>
                                                        <input
                                                            type="text"
                                                            className="form-control border-0 shadow-none p-0"
                                                            value={engineUnitUsage}
                                                            onChange={(e: any) => setEngineUnitUsage(e.target.value)}
                                                            onKeyPress={CommonUtil.allowNumbersDecimal}
                                                        />
                                                        <span style={{ fontSize: '10px', marginLeft: '2px' }}>h/day</span>
                                                    </div>
                                                )}
                                            </td>
                                        )}
                                        <td style={{ paddingLeft: '30px', paddingTop: '10px' }}>{subItem.refund}</td>
                                    </tr>
                                ))}
                            </React.Fragment>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default PricingDetailsTable;
